export default __webpack_public_path__ + "static/media/twitter-icon.97bcdb4a.png";